<template>
    <div class="directory-inline-form">
            <div class="form-group">
                <label :class="{ 'required-style': !officeData.officeName }">{{ $t('Office Name') }}</label>
                <input type="text" class="form-control" v-model="officeData.officeName" :placeholder="$t('Office Name')"/>
                <span class="text-warning" v-if="!officeData.officeName && isClicked">{{ $t('Required') }}</span>
            </div>
            <div class="form-group">
                <label :class="{ 'required-style': !officeData.regionId }">{{ $t('Region') }}</label>
                <select class="form-select text-capitalize" v-model="officeData.regionId">
                    <option value="">{{ $t('Select Region') }}</option>
                    <option v-for="(item, key) in regionDropDownList" :key="key" :value="item._id">{{item.regionName}}</option>
                </select>
                <span class="text-warning" v-if="!officeData.regionId && isClicked">{{ $t('Required') }}</span>
            </div>
            <div class="directory-inline-form__actions">
                <button class="btn btn-primary directory-save-btn" ref="saveBtn" @click="CreateOffice"><i class="fa-solid fa-floppy-disk"></i> {{ $t('Save Office') }}</button>

            </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {showDirectoryError} from '@/helpers/directoryErrorAlert.js'
import {showDirectorySuccess} from '@/helpers/directorySuccessAlert.js'
import {showDirectoryLoading, closeDirectoryLoading} from '@/helpers/directoryLoadingAlert.js'

export default {
    name : 'OfficeForm',
    computed : mapGetters(['regionDropDownList']),
    data(){
        return {
            officeData : {
                regionId : ""
            },
            isClicked : false
        }
    },
    methods :{
        ...mapActions(['GetRegionListDropdown','CreateOfficeRun']),
        CreateOffice(){
            const self = this
            const btn = self.$refs.saveBtn
            let data = self.officeData
            self.isClicked = true
            if(!data.officeName || !data.regionId){
                return
            }
            
            btn.disabled = true
            self.isClicked = false
            showDirectoryLoading(self, {
                title: 'Creating Office',
                description: 'Saving the office and updating the directory.'
            })

            self.CreateOfficeRun(data).then((res)=>{
                btn.disabled = false
                if(res=="OK"){
                    self.officeData = { regionId : ""}
                    closeDirectoryLoading(self)
                    showDirectorySuccess(self, {
                        description: 'The office has been created successfully and added to the directory.'
                    })
                }else{
                    closeDirectoryLoading(self)
                    showDirectoryError(self, {
                        description: res,
                        duplicateValue: data.officeName
                    })
                }
            }).catch((error)=>{
                btn.disabled = false
                closeDirectoryLoading(self)
                showDirectoryError(self, {
                    description: error?.message || 'Unable to create office. Please try again.',
                    duplicateValue: data.officeName
                })
            })
        }
    }
}
</script>
